import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {setSelectedCurrency} from "../actions/currencyActions";
import {useDispatch, useSelector} from "react-redux";
import {PropTypes} from "prop-types";

const CurrencySelectContainer = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
    width: 100%;
    justify-content: end;
    span {
        font-size: 1rem;
        margin-right: 5px;
    }
    i {
        margin-right: 5px;
        font-size: 1.5rem;
        color: ${props => props.theme.buttonBackground};
    }
`

const CurrencySelect = ({prices}, context) => {
    const selectedCurrency = useSelector(state => state.currency.selectedCurrency);
    const dispatch = useDispatch();

    const [toggleValue, setToggleValue] = useState(false);
    const [availableCurrencies, setAvailableCurrencies] = useState([]);

    useEffect(() => {
        if (prices.length > 1) {
            setAvailableCurrencies([prices[0].currencySymbol, prices[1].currencySymbol]);
            if (prices[1].currencySymbol === selectedCurrency) {
                setToggleValue(true);
            }
        }
    },[prices, selectedCurrency])

    const handleCurrencyChange = () => {
        if (selectedCurrency === availableCurrencies[0]) {
            dispatch(setSelectedCurrency(availableCurrencies[1]));
        } else {
            dispatch(setSelectedCurrency(availableCurrencies[0]));
        }
        setToggleValue(prev => !prev);
    }

    if (availableCurrencies.length < 1) {
        return null
    }

    //Edge case error message
    if (availableCurrencies.length > 0 && availableCurrencies[0] !== selectedCurrency && availableCurrencies[1] !== selectedCurrency ) {
        console.error(`The currently selected currency is not in the list of available currencies. Selected: ${selectedCurrency}, Available: ${availableCurrencies[0]}, ${availableCurrencies[1]}`)
        return null;
    }

    return (
        <CurrencySelectContainer>
            <span>{context.t('show_prices_in')}:</span>
            <span>{availableCurrencies[0]}</span>
            <i
                className={ toggleValue ? "fa fa-toggle-on" : "fa fa-toggle-off" }
                onClick={handleCurrencyChange}>
            </i>
            <span>{availableCurrencies[1]}</span>
        </CurrencySelectContainer>
    );
};

CurrencySelect.contextTypes = {
    t: PropTypes.func.isRequired
}

export default CurrencySelect;